import {Arrow, Content, Portal} from '@radix-ui/react-tooltip';
import clsx from 'clsx';

import type {TooltipContentProps} from '@radix-ui/react-tooltip';

export function TooltipContent({
  ref: forwardedRef,
  children,
  className,
  ...props
}: TooltipContentProps &
  React.RefAttributes<HTMLDivElement>): React.JSX.Element {
  return (
    <Portal>
      <Content
        {...props}
        ref={forwardedRef}
        className={clsx(
          className,
          'max-h-radix-tooltip-content-available max-w-radix-tooltip-content-available rounded-md bg-slate1 px-3 py-2 text-base shadow-md outline-1 -outline-offset-1 outline-slate6 focus-visible:outline-2 sm:text-sm radix-side-bottom:animate-slide-up-and-fade radix-side-left:animate-slide-right-and-fade radix-side-right:animate-slide-left-and-fade radix-side-top:animate-slide-down-and-fade'
        )}
      >
        {children}

        <Arrow className="fill-slate1" />
      </Content>
    </Portal>
  );
}

TooltipContent.displayName = 'TooltipContent';
